export enum ADMINISTRATORS_ORDER_COLUMNS {
  CPF = 'CPF',
  NAME = 'NAME',
  EMAIL = 'EMAIL',
}
